import { appHttpClient } from "../../installations/http/axiosInterfaces";

export const addProduct = (data) => {
    return appHttpClient.post(`/Product/Add`, data);
};

export const updateProduct = (data) => {
    return appHttpClient.post(`/Product/Update`, data);
};

export const deleteProduct = (productId) => {
    return appHttpClient.get(`/Product/Delete/${productId}`);
};

export const getProductById = (productId) => {
    return appHttpClient.get(`/Product/${productId}`);
};

export const getProducts = (queryParams) => {
    return appHttpClient.get(`/Product/GetProducts`, { params: queryParams });
};

export const addProductImage = (productId, file, isPrimary) => {
    const formData = new FormData();
    formData.append("file", file);
    return appHttpClient.post(`/Product/Update/Image/${productId}/${isPrimary}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data", // Inform the server that this is form data
        },
      });
};

export const deleteProductImage = (productId, imageId) => {
    return appHttpClient.get(`/Product/Delete/Image/${productId}/${imageId}`);
};

export const setImageAsPrimary = (productId, imageId) => {
    return appHttpClient.get(`/Product/Update/Image/Primary/Set/${productId}/${imageId}`);
};

export const attachProduct = (productId, attachedProductId) => {
    return appHttpClient.post(`/Product/Attach/${productId}/${attachedProductId}`);
  };
  
  export const unattachProduct = (productId, attachedProductId) => {
    return appHttpClient.post(`/Product/Unattach/${productId}/${attachedProductId}`);
  };

  
const productService = {
    addProduct,
    updateProduct,
    deleteProduct,
    getProductById,
    getProducts,
    addProductImage,
    deleteProductImage,
    setImageAsPrimary,
    attachProduct,
    unattachProduct,
};

export default productService;
